import { config } from 'cfg'

export const FILES_ENDPOINTS = {
  files: () => `${config.apiBaseUrl}/files`,
  file: (fileId: number) => `${FILES_ENDPOINTS.files()}/${fileId}`
}
